export class ProductInstructionDto {
  instructionType: string;
  instructionText: string;
  id?: string;

  constructor(d?: ProductInstructionDto) {
    if (!d) {
      return;
    }

    this.instructionType = d.instructionType;
    this.instructionText = d.instructionText;
    this.id = d.id;
  }
}
